(function (global) {
  const allowedCharacter = /^[A-Za-z0-9 \n.,!?'"&()\-+\/:;]$/;

  const normalizeEngravingText = (value) => String(value || "").replace(/\r\n?/g, "\n");

  const findUnsupportedCharacters = (value) => {
    const unsupported = [];
    for (const character of normalizeEngravingText(value)) {
      if (!allowedCharacter.test(character) && !unsupported.includes(character)) {
        unsupported.push(character);
      }
    }
    return unsupported;
  };

  const formatUnsupportedCharacters = (value) => findUnsupportedCharacters(value).join(" ");

  const isSupportedEngravingText = (value) => findUnsupportedCharacters(value).length === 0;

  const api = {
    findUnsupportedCharacters,
    formatUnsupportedCharacters,
    isSupportedEngravingText,
    normalizeEngravingText
  };

  if (typeof module !== "undefined" && module.exports) module.exports = api;
  global.KovaEngravingText = Object.freeze(api);
})(globalThis);
